import { BaseResidentParameterDto } from '../../_models/base-resident-parameter-dto';

export class DocumentParamterDto extends BaseResidentParameterDto {
  category: string;
  subCategory: string;
  month: number;
  year: number;

  constructor(
    customerId?: string,
    communityId?: number,
    category?: string,
    subCategory?: string,
    month?: number,
    year?: number
  ) {
    super(customerId, communityId);
    this.communityId = communityId;
    this.customerId = customerId;
    this.category = category;
    this.subCategory = subCategory;
    this.month = month;
    this.year = year;
  }

  override getQueryString(): string {
    let urlStr = `?customerId=${this.customerId}&communityId=${this.communityId}&clearCache=${this.clearCache}`;
    if (!!this.category) {
      urlStr += `&category=${this.category}`;
    }
    if (!!this.subCategory) {
      urlStr += `&subcategory=${this.subCategory}`;
    }
    if (!!this.month) {
      urlStr += `&month=${this.month}`;
    }
    if (!!this.year) {
      urlStr += `&year=${this.year}`;
    }

    return urlStr;
  }
}
